import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@nextui-org/button'
import { headerStyles } from './styles'

const Result = ({ result, resetSimulator }) => {
  useEffect(() => {
    // Esta función se ejecutará cuando el componente se monte
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
      <div className="animate-fade rounded-3xl border-2 border-primary transition-all duration-300 my-5 md:w-[70%] lg:w-[60%] xl:w-[50%] 2xl:w-[25%] p-10 transition-all duration-300 shadow-propital dark:shadow-none mx-auto">
        <h1 className="text-primary text-center font-extrabold text-2xl my-10">
          Puedes pedir un crédito <br />
          hipotecario de hasta:
        </h1>

        <p className="text-center font-extrabold text-2xl my-10 bg-[#fc2cd2] w-5/6 md:w-2/3 lg:w-1/1 px-2 py-4 text-white rounded-full mx-auto">
          {result} UF
        </p>
      </div>

      <div className={`${headerStyles.BUTTON}`}>
        <Button
          type="submit"
          color="primary"
          size="lg"
          className="rounded-3xl font-bold text-lg"
          variant="shadow"
          onClick={() => resetSimulator()}
        >
          Hacer otra simulación
        </Button>
      </div>
    </>
  )
}

Result.propTypes = {
  result: PropTypes.number.isRequired,
  resetSimulator: PropTypes.func.isRequired,
}

export default Result
